import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "Store/hooks";

import getGitBlobContent from "../thunk/getGitBlobContent.thunk";

import type { Blob } from "@packages/client";

const useGetGitBlobContent = (blob?: Blob) => {
  const blobContent = useAppSelector(
    state => state.git?.blob?.[blob?.sha || ""] || {}
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getGitBlobContent(blob));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blob?.sha]);
  return blobContent;
};

export default useGetGitBlobContent;
